import React, { useEffect } from "react";
import { WEBAPPLINK, domainName } from "src/utils/config";
import Cookies from "universal-cookie";

type Props = {
  timeout: number;
};

const AutoLogout: React.FC<Props> = ({ timeout }) => {
  const cookies = new Cookies();
  let interval = null;
  let timeouttrackr = null;

  const updateExpiredTime = () => {
    if (timeouttrackr != null) clearTimeout(timeouttrackr);

    timeouttrackr = setTimeout(writeExpiredTime, 300);
  };

  const tracker = () => {
    window.addEventListener("mousemove", updateExpiredTime);
    window.addEventListener("scroll", updateExpiredTime, { passive: true });
    window.addEventListener("keydown", updateExpiredTime);
  };

  // Before path: "/" was set explicitly, _expiredTime was written with no path,
  // so the browser scoped it to the directory of whatever page wrote it. Those
  // copies now sit on nested paths (e.g. /goal-predictions) where they outrank
  // the root one — cookies are read longest-path-first — and nothing removes
  // them, because every write and delete now targets "/". A stale copy makes
  // this component log the user out on every load of that route.
  const clearLegacyExpiredTime = () => {
    const segments = window.location.pathname.split("/").filter(Boolean);
    let current = "";
    segments.forEach((segment) => {
      current += `/${segment}`;
      cookies.remove("_expiredTime", { domain: domainName, path: current });
    });
  };

  const writeExpiredTime = () => {
    cookies.set("_expiredTime", `${Date.now() + timeout * 1000}`, {
      domain: domainName,
      path: "/",
      maxAge: timeout,
    });
  };

  const clean = () => {
    cookies.remove("_expiredTime", { domain: domainName, path: "/" });
    clearInterval(interval);
    window.removeEventListener("mousemove", updateExpiredTime);
    window.removeEventListener("scroll", updateExpiredTime);
    window.removeEventListener("keydown", updateExpiredTime);
  };

  const startInterval = () => {
    updateExpiredTime();

    interval = setInterval(() => {
      const expiredTime = parseInt(cookies.get("_expiredTime"), 10);

      // Timout
      if (expiredTime < Date.now()) logout();
    }, 1000);
  };

  const logout = () => {
    clean();
    if (cookies.get("JWToken")) {
      cookies.remove("JWToken", { domain: domainName, path: "/" });
      window.location.href = `${WEBAPPLINK}`;
    }
  };

  useEffect(() => {
    clearLegacyExpiredTime();
    // A page load means the user just acted, so start a fresh idle window.
    // Trusting the stored timestamp here logged people out on refresh using a
    // value left over from an earlier session, before it could be refreshed.
    writeExpiredTime();

    tracker();
    startInterval();

    return () => {
      clean();
    };
    // eslint-disable-next-line
  }, []);

  return <></>;
};

export default AutoLogout;
